<div class="dialog-header" cdkDrag cdkDragRootElement=".cdk-overlay-pane">
  <div class="header-side"></div>
  <div class="dialog-title-text" cdkDragHandle>
    {{ getHeaderText() }}
  </div>
 <button mat-icon-button class="close-btn" (click)="onCancel()">
    <mat-icon>close</mat-icon>
  </button>
</div>
<mat-dialog-content>
  <form [formGroup]="upsertDepackForm">
    <div class="form-grid">
      <div class="form-grid-row cols-4">
        <div class="form-grid-row span-1">
          <app-select-search (selectedItemId)="onStatusReceived($event)" [selectItems]="selectStatusItems"
            formControlName="fsStatusId"
            [isrequired]="true" [matcher]="matcher"
            [invalid]="!!(upsertDepackForm.get('fsStatusId')?.invalid && (upsertDepackForm.get('fsStatusId')?.touched || attemptSave()))"
            selectTitle="Status" [setId]="fsStatusId"></app-select-search>
        </div>
        <div class="form-grid-row span-1">
          <mat-form-field appearance="outline">
            <mat-label>Date Received</mat-label>
            <input data-testid="actualDate" formControlName="actualDate" id="actualDate"
              matInput [matDatepicker]="actualDatePicker" name="actualDate" 
              (keydown)="onKeydown($event)" (blur)="dateformat($event)" />
            <mat-datepicker-toggle matSuffix [for]="actualDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #actualDatePicker></mat-datepicker>
            <mat-error *ngIf="upsertDepackForm.get('actualDate')?.hasError('required')">
              Quantity is required
            </mat-error>
          </mat-form-field>
        </div>

        <div class="form-grid-row span-2">
          <app-select-search (selectedItemId)="onSiteReceived($event)" [selectItems]="selectSiteItems" formControlName="sid"
            [isrequired]="true" [matcher]="matcher"
            [invalid]="!!(upsertDepackForm.get('sid')?.invalid && (upsertDepackForm.get('sid')?.touched || attemptSave()))"
            selectTitle="Site" [setId]="siteId"></app-select-search>
        </div>
      </div>
      <div class="form-grid-row cols-4">
        <div class="form-grid-row">
          <app-select-search (selectedItemId)="onCustomerReceived($event)" [selectItems]="selectCustomerItems" formControlName="generatorId"
            [isrequired]="true" [matcher]="matcher"
            [invalid]="!!(upsertDepackForm.get('generatorId')?.invalid && (upsertDepackForm.get('generatorId')?.touched || attemptSave()))"
            selectTitle="Customer" [setId]="generatorId" formControlName="generatorId"></app-select-search>
        </div>
        <div class="form-grid-row">
          <app-select-search (selectedItemId)="onHaulerReceived($event)" [selectItems]="selectHaulerItems"
            [isrequired]="true" [matcher]="matcher"
            [invalid]="!!(upsertDepackForm.get('hid')?.invalid && (upsertDepackForm.get('hid')?.touched || attemptSave()))"
            selectTitle="Hauler" [setId]="haulerId" formControlName="hid"></app-select-search>
        </div>
        <div class="form-grid-row">
          <mat-form-field appearance="outline">
            <mat-label>Truck Number</mat-label>
            <input matInput type="text" data-testid="truckNumber" formControlName="truckNumber" maxlength="20"
              name="truckNumber" />
          </mat-form-field>
        </div>
        <div class="form-grid-row">
          <mat-form-field appearance="outline">
            <mat-label>Trailer Number</mat-label>
            <input matInput type="text" maxlength="20" name="trailerNumber" formControlName="trailerNumber" />
          </mat-form-field>
        </div>
      </div>
      <div class="form-grid-row cols-4">
        <div class="form-grid-row span-2">
          <mat-form-field appearance="outline">
            <mat-label>Customer Location</mat-label>

            <mat-select formControlName="location"
                        (selectionChange)="onCustomerLocationReceived($event.value)">

              <mat-option [value]="null">-- Select Customer Location --</mat-option>

              @for (location of customerLocations; track location.id) {
              <mat-option [value]="location.name">
                {{ location.name }}
              </mat-option>
              }
            </mat-select>

            <mat-error *ngIf="upsertDepackForm.get('location')?.hasError('required') &&
                    (upsertDepackForm.get('location')?.touched || attemptSave())">
              Customer Location is required.
            </mat-error>
          </mat-form-field>
        </div>
        <div class="form-grid-row span-2">
          <mat-form-field appearance="outline">
            <mat-label>Driver's Name</mat-label>
            <input matInput type="text" maxlength="50" data-testid="driverName" name="driverName"
              formControlName="driverName" />
          </mat-form-field>
        </div>
      </div>
      <div class="form-grid-row cols-5">
        <div class="form-grid-row span-1">
          <mat-form-field appearance="outline">
            <mat-label>BOL #</mat-label>
            <input matInput type="text" name="bol" formControlName="bol" maxlength="20" />
          </mat-form-field>
        </div>
        <div class="form-grid-row span-1">
          <mat-form-field appearance="outline">
            <mat-label>Seal #</mat-label>
            <input matInput type="text" name="seal" formControlName="seal" maxlength="20" />
          </mat-form-field>
        </div>
        <div class="form-grid-row span-1">
          <mat-form-field appearance="outline">
            <mat-label>Customer PO #</mat-label>
            <input matInput type="text" name="customerPo" formControlName="customerPO" maxlength="20" />
          </mat-form-field>
        </div>
        <div class="form-grid-row span-1">
          <mat-form-field appearance="outline">
            <mat-label>Pickup #</mat-label>
            <input matInput type="text" name="pickup" formControlName="pickUp" maxlength="20" />
          </mat-form-field>
        </div>
        <div class="form-grid-row span-1">
          <mat-form-field appearance="outline">
            <mat-label>Release #</mat-label>
            <input matInput type="text" name="release" formControlName="release" maxlength="20" />
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="form-grid">
      <div class="form-grid-row">
        <app-streams-grid  [generatorId]="generatorId" [sid]="sid" [hid]="hid" [locName]="locName" [loadStreams]="loadStreams"
          [fsLoadId]="fsLoadId" [actualDate]="actualDate" (loadStreamsEvent)="onStreamAddedOrUpdated($event)"></app-streams-grid>
      </div>
    </div>
    <div class="form-grid">
      <div class="form-grid-row">
        <div>
          <mat-form-field appearance="outline">
            <mat-label>Notes For Customer</mat-label>
            <textarea matInput maxlength="500" rows="3" formControlName="notesForCustomer"></textarea>
          </mat-form-field>

          <mat-form-field appearance="outline" style="padding-top: 10px;">
            <mat-label>Notes For Hauler</mat-label>
            <textarea matInput maxlength="500" rows="3" formControlName="notesForHauler"> </textarea>
          </mat-form-field>

          <mat-form-field appearance="outline" style="padding-top: 10px;">
            <mat-label>Load Notes (Internal)</mat-label>
            <textarea matInput maxlength="500" rows="3" formControlName="internalNotes"></textarea>
          </mat-form-field>
          <div class="form-grid-row cols-2">
            <mat-slide-toggle formControlName="holdLoadOnComplete">
              Hold Load On Complete
            </mat-slide-toggle>
            <mat-slide-toggle formControlName="isInvoiceThisLoad">
              Invoice This Load
            </mat-slide-toggle>
          </div>
        </div>

        <div>

        </div>

        <div>
          <mat-form-field appearance="outline">
            <mat-label>Freight Charge</mat-label>
            <input matInput readonly formControlName="freightCharge">
          </mat-form-field>

          <mat-form-field appearance="outline" style="padding-top: 10px;">
            <mat-label>Zero Volume Fee</mat-label>
            <input matInput formControlName="zeroVolumeFee">
          </mat-form-field>
          <mat-form-field appearance="outline" style="padding-top: 10px;">
            <mat-label>Fee Category</mat-label>
            <mat-select multiple formControlName="feeCategories"name="feeCategoryId"
              (selectionChange)="onFeeCategoryChange($event.value, true)">
              @for (fee of feeCategories; track fee.id) {
                <mat-option [value]="fee.id">
                  {{ fee.name }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          
          <br />
          <table class="fee-summary-table" *ngIf="selectedFeeCategoryRows.length > 0">
            <tr *ngFor="let item of selectedFeeCategoryRows">
              <td>{{ item.name }}</td>
              <td>{{ item.value | currency }}</td>
            </tr>
          </table>
          
          <div class="rebate-reduction">
            Rebate Reduction
            <span>{{ rebateReduction | currency }}</span>
          </div>
          
          <hr />
          
          <div class="final-total">
            TOTAL
            <span>{{ finalTotal | currency }}</span>
          </div>
        </div>
      </div>
    </div>
  </form>

</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button color="primary" mat-primary (click)="onAttachDocument()">
    <mat-icon>attach_file</mat-icon>
    Attach Document
  </button>
  <button data-testid="btnReset" mat-raised-button color="primary" mat-primary (click)="onReset()">
    Reset
  </button>
  <button data-testid="btnCancel" mat-raised-button color="primary" mat-primary (click)="onCancel()">
    Cancel
  </button>
  <button data-testid="btnSave" mat-raised-button color="primary" mat-primary (click)="onSave()">
    Save
  </button>
</mat-dialog-actions>
